import { mdiMagnify, mdiMenu } from '@mdi/js'
import contentApi from '@/api/content'
import firebase from '@/api/firebase'
export default {
  data: () => ({
    user: null,
    showProgressCircular: false,
    // TODO(vignatti): Move experiencesContent, count, searchQuery and area all
    // inside 'experiences' array
    experiencesContent: {
      '360': [],
      'labs': [],
      '3d': [],
    },
    count: {
      '360': -1,
      'labs': -1,
      '3d': -1,
    },
    area: {
      '360': '',
      'labs': '',
      '3d': '',
    },
    mdiMagnify, mdiMenu,
    size: 1000,
    shownExperience: 3,
    nextToken: {
      '360': '',
      'labs': '',
      '3d': '',
    },
    typesExperience: ['360', '3d', 'labs'],
    experienceType: '',
    experienceQuery: '',
  }),
  watch: {
    '$route.query.type'(val) {
      this.experienceType = val

      this.setTypeQueryAndSearch(this.experienceType, this.experienceQuery)
    },
    '$route.query.query'(val) {
      this.experienceQuery = val

      this.setTypeQueryAndSearch(this.experienceType, this.experienceQuery)
    },
  },
  mounted () {
    // TODO(vignatti): we want to use Vuex instead
    this.$bus.$on('search-experience-area', (searchArea) => {
      this.setAreaAndSearch(searchArea)
    })

    this.experienceType = this.$route.query.type
    this.experienceQuery =  this.$route.query.query

  },
  async created() {
    this.showProgressCircular = true
    await this.getUserByEmail()
    await this.getUserData()
    this.getExperiences()
    this.showProgressCircular = false
  },
  methods: {
    async getUserByEmail() {
      let vm = this
      let params = {
        'userEmail' : JSON.parse(localStorage.getItem('user')).email
      }
      let userForEmail = await firebase.getUserByEmail(params)
      userForEmail.forEach(
        await function(doc) {
          vm.user = {}
          vm.user.uid = doc.id
          vm.user.role = doc.data().role
          vm.user.displayName = JSON.parse(localStorage.getItem('user')).displayName
        }
      )
    },
    async getUserData() {
      let vm = this
      let experiences = []
      let i = 0
      let params = {
        'userId' : this.user.uid
      }
      let data = await firebase.getUserLists(params)
      data.forEach (
        await function(doc) {
          experiences.push(doc.data())
          experiences[i].name = doc.id
          vm.user.lists = experiences
          i += 1
        }
      )
    },
    changeRoute(type){
      let searchRoute = 'ContentSearch'

      this.$router.push({ name: searchRoute,
          query: { query: this.experienceQuery, type: type } })
    },

    setTypeQueryAndSearch(type, query) {
      this.getExperiences(query)
    },

    setAreaAndSearch(area) {
      this.getExperiences(this.experienceQuery, area)
    },

    clearContent(type) {
      this.nextToken[type] = ''
      this.experiencesContent[type] = []
    },

    getExperiences(query = this.experienceQuery, area = '') {
      for(let i = 0; i < this.typesExperience.length; i++){
        this.clearContent(this.typesExperience[i])
        this.getExperiencesByType(this.typesExperience[i], query, area)
        .then(items => {
          if (items.length) {
            this.experiencesContent[this.typesExperience[i]] = this.experiencesContent[this.typesExperience[i]] = items
            if(this.experiencesContent[this.typesExperience[i]].length > this.shownExperience){
              this.experiencesContent[this.typesExperience[i]].length = this.shownExperience
            }
          }
        })
      }
    },

    getExperiencesByType(type, query, area) {
      // Prevent further searches after hitting the end of the results
      if (this.nextToken[type] === null)
        return Promise.resolve([])

      return contentApi.searchLearningObjects(type, query, area, this.size, this.nextToken[type])
      .then(list => {
        this.count[type] = list.total
        this.nextToken[type] = list.nextToken
        return list.items
      })
      .catch((error) => {
        console.error(error)
        return Promise.resolve([])
      })
    },
  }
}
